import styled from "styled-components";
import { motion } from "framer-motion";

export const Detalhes = styled(motion.div)`
    width: calc(100% - 320px);
    height: 230px;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 15px;

    p.Detalhamento__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
        font-size: 14px;
        margin: 0;
        padding: 0;
    }

    div.Detalhamento__cards {
        width: 100%;
        display: grid;
        grid-gap: 10px; 
        /* grid-template-columns: repeat(auto-fit, minmax(139px, 1fr)); */
        grid-template-columns: 1fr 1fr 1fr;
        margin-top: 5px;
    }
`;